import React from 'react';
import { useSelector } from 'react-redux';

import * as providerSelectors from '../../../entities/providers/selectors';

import { EasyPackMap } from '../easy-pack-map';
import { DropOfPoint } from '../easy-pack-map/types';

interface Props {
  onSelect?: (point: DropOfPoint) => void;
}

export const DropOffMap: React.FC<Props> = ({ onSelect }) => {
  const useDropOffMap = useSelector(providerSelectors.showDropOffMap);

  return <>{useDropOffMap && <EasyPackMap onSelect={onSelect} />}</>;
};
